import { IBaseTariffApi } from "~/entity/Tariffs";

export type TariffSetType = "Срочный" | "Бессрочный";

export interface IBaseTariffRow {
  id: string;
  instanceId: string;
  position: string;
  positions: string[];
  price: string;
  type: TariffSetType | "";
  createdAt: string;
  updatedAt: string;
  author: string;
}

export const mapBaseTariffApiToRow = (
  tariff: IBaseTariffApi,
): IBaseTariffRow => {
  const positions = (tariff.positions ?? []).map(
    (position) => `${position.code}. ${position.name}`,
  );

  return {
    id: tariff.id,
    instanceId: String(tariff.instanceId),
    position: positions[0] || "",
    positions,
    price: tariff.price || "",
    type: tariff.actualTo ? "Срочный" : "Бессрочный",
    createdAt: tariff.createdAt || "",
    updatedAt: tariff.updatedAt || "",
    author: tariff.authorName || "",
  };
};
